import React, { useState } from "react";
import styled from "styled-components";
import BackgroundImage from "../components/BackgroundImage";
import background from "../assets/home.webp";
import elImg from "../assets/uploadEL.webp";
import upload from "../assets/home_upload.webp";
import analysis from "../assets/view.webp";
import about from "../assets/home_about.webp";
import coming_1 from "../assets/coming_soon_1.webp";
import coming_2 from "../assets/coming_soon_2.webp";
import coming_3 from "../assets/coming_soon_3.webp";
import Navbar from "../components/Navbar";
import LeftScrollbar from "../components/LeftScrollbar";
import LandingCard from "../components/LandingCard";
import { Helmet } from "react-helmet";
// import { useDispatch } from 'react-redux';
// import {fetchHighLevel} from "../store/index"

function Home() {
    // const [isScrolled, setIsScrolled] = useState(false);
    const links = [
        { name: "Home", link: "/landing" , isActive: true},
        { name: "Upload new images", link: "/upload", isActive:false },
        { name: "View analysis", link: "/resultsHighLevel", isActive:false },
        { name: "About", link: "/about", isActive: false},
        { name: "Help", link: "/help", isActive: false}
        // { name: "Contact us", link: "/contactUs", isActive:false },
      ];

    const card_info_1 = [
        {title: "Upload EL images", description: ["Upload new batches of EL images and use state-of-the-art AI to perform analysis.", "Add new images to existing batches"], img_src:elImg, link: "/upload"},
        {title: "View analysis", description: ["Visualize PV Defects & Features", "Analyse Batch, Module & Cell level statistics", "Generate statistical reports"], img_src:analysis, link: "/resultsHighLevel"},
        {title: "About SolarAIDD", description: ["View information on the criteria of defects", "View information on the criteria for PV features"], img_src:about, link: "/about"}
    ]
    
    const card_info_2 = [
        {title: "Evaluate & Score Image Quality", description: ["Obtain a score that measures solar panel quality based on defects", "Contrast quality measures between different panels in the same batch", "Gauge lifespan of existing panels based on analysis"], img_src:coming_1},
        {title: "Integrate additional data sources", description: ["Incorporate data information about the solar panel such as electrical efficiency", "Enrich the analysis with other parameters from the manufacturing process", "Evaluate panels over time with drone imagery to gauge deterioration"], img_src:coming_2},
        {title: "Generate Sophisticated Reports", description: ["Create intuitive and informative reports that collate images and statistics to provide a holistic few of Solar PV quality", "Support custom reports", "Generate interactive reports and widgets"], img_src:coming_3}
    ]

return (
    <Container>
        <Helmet>
            <title>Home | SolarAIDD</title>
            <meta name="description" content="Access the SolarAIDD dashboard to upload EL image batches. Perform instant AI-driven defect detection for solar modules and generate detailed health reports."/>
            <meta name="keywords" content="solar EL image upload, AI defect analysis dashboard, PV module health report, batch solar inspection, automated solar cell tagging, SolarAIDD portal"/>
            <meta name="robots" content="index, follow" />
            <link rel="canonical" href="https://solaraidd.csir.co.za/landing" />
        </Helmet>
        {/* <BackgroundImage background={background} /> */}
        <Navbar links={links} isScrolled={true}/>
    
        <LeftScrollbar/>
        <div className="container">
            <div className="header" > 
                <img src={background} alt="Header" />
                <div className="title">
                    <h1> Welcome to SolarAIDD </h1>
                    <h4> The smart AI tool to analyse and grade solar PV modules. </h4> 
                </div>
            </div> 
            <div className="box">
                {card_info_1.map((ci, index) => {
                    return <LandingCard title={ci['title']} description={ci['description']} img_src={ci['img_src']} link={ci['link']} key={index} />;
                })}
            </div>
            <h2> Coming soon </h2>
            <div className="box">
                {card_info_2.map((ci, index) => {
                    return <LandingCard title={ci['title']} description={ci['description']} img_src={ci['img_src']} key={index} />;
                })}
            </div>
        </div>
    </Container>
);
}

export default Home;

const Container = styled.div`

background: #d2d9dd;
.container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    color: black;
    background: #d2d9dd;
    display: flex;  
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;    
    .header {
        width: 100vw;
        height: 20rem;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        } 
        .title {
            width: 500px;
            height: 20rem;
            position: absolute;
            top: 7rem;
            left: 10rem;
            color: black;
            text-align: left;
            display: flex;  
            flex-direction: column;
            gap: 1.5rem;
        }               
    } 
    .box {
        display: flex;  
        flex-direction: row;
        gap: 4rem;
        padding: 2rem;
    }
}`


// const Container = styled.div`
// position: relative;
// .container {
//     position: absolute;
//     top: 6.5rem;
//     left: 0;
//     width: 100vw;
//     .title {
//         text-align: center;
//     }
//     .grid {
//         width: 100vw;   
//         .row {
//             display: flex;
//             gap: 2rem;
//             padding: 2rem;
//             .block {            
//                 justify-content: center;
//                 padding: 5rem;
//                 background-color: #000000b0;
//                 width: 50vw;
//             }
//         }  
//     }
// }
// `;
